module.exports = __webpack_public_path__ + "static/media/logo.e6dd4ea9.png";